import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import FeaturesGrid from "@/components/FeaturesGrid";
import StatsSection from "@/components/StatsSection";
import PricingSection from "@/components/PricingSection";
import InterestForm from "@/components/InterestForm";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-black text-white">
      <Navbar />
      <Hero />
      <FeaturesGrid />
      <StatsSection />
      <PricingSection />
      <InterestForm />
      <Footer />
    </div>
  );
}
